"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f246 = void 0;
exports.f246 = {
    "ömie": [
        358
    ],
    "ögs": [
        475
    ],
    "österreichische gebärdensprache": [
        475
    ],
    "österreichische": [
        475
    ],
    "österreichisches deutsch": [
        1783
    ],
    "österreichisches": [
        1783
    ],
    "ökönyöñ": [
        3749
    ],
    "öñge": [
        5939
    ],
    "önge": [
        5939
    ],
    "övdalian": [
        6004
    ],
    "övdalsk": [
        6004
    ],
    "övdalska": [
        6004
    ],
    "övkallmå̢leð": [
        6004
    ],
    "övkallmǫleð": [
        6004
    ],
    "özbek": [
        8038,
        8039,
        8040,
        8042,
        8043
    ]
};
